"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordNotifierService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordNotifierService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordNotifierService.instance) {
      return CordNotifierService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordNotifierService.instance = this;
  }
  getNotifications() {
    return this.get(`notifications`);
  }
  getNotification(id) {
    return this.get(`notifications/${id}`);
  }
  postNotification(data) {
    return this.post('notifications', data);
  }
  updateNotification(id, data) {
    return this.patch(`notifications/${id}`, data);
  }
  deleteNotification(id) {
    return this.delete(`notifications/${id}`);
  }
  subscribeToNotification(data) {
    return this.post('subscriptions', data);
  }
  getSubscriptions() {
    return this.get('subscriptions');
  }
  deleteSubscription(category, deviceId) {
    return this.delete(`subscriptions/${category}/${deviceId}`);
  }
}
exports.CordNotifierService = CordNotifierService;
CordNotifierService.instance = null;
